<template>
  <div v-loading="loading" style="min-height: 150px">
    <no-data v-if="isNoData" />
    <Collapse v-for="(address,index) in addressList" :key="index" :open="index==0" @change="CollapseChange($event,address)">
      <div slot="header" style="font-size: 15px;">
        配送至：{{ address.address }}  {{ address.addressName }} {{ address.contactNumber }}
      </div>
      <div v-loading="address.Loading" style="padding: 15px 10px;">
        <el-table :data="address.orderProductInfoList" border style="width: 100%" :summary-method="getSummaries" show-summary>
          <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
          <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
          <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
          <el-table-column prop="counct" label="数量" align="left" width="60">
            <template v-slot="{row}">
              {{ Number(row.counct).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="productUnit" label="单位" align="left" width="60" />
          <el-table-column prop="shippedCount" label="已发货数量" align="left" width="90">
            <template v-slot="{row}">
              {{ Number(row.shippedCount).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="unShippedCount" label="未发货数量" align="left" width="90">
            <template v-slot="{row}">
              {{ Number(row.unShippedCount).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="sellingBack" label="销退数量" align="left" width="90">
            <template v-slot="{row}">
              {{ Number(row.sellingBack).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="pname" label="是否购买PSC" align="left">
            <template v-slot="{row}">
              {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
            </template>
          </el-table-column>
          <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
          <el-table-column prop="taxRate" label="税率" align="right" header-align="left" width="60">
            <template v-slot="{row}">
              {{ row.taxRate }}%
            </template>
          </el-table-column>
          <el-table-column prop="pname" label="序列号" align="left" fixed="right" width="60">
            <template v-slot="{row}">
              <lookserial-number :str-contract-code="strContractCode" :product-name="row.productName" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </Collapse>
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import noData from '@/components/noData';
import lookserialNumber from './lookserialNumber';
import axios, { getContractInfoAddressList, getDesensitizationContractInfoDeatil } from '@/API';
export default {
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      addressList: [],
      exportLoading: false
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {
    Collapse,
    noData,
    lookserialNumber
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractInfoAddressList(this.strContractCode).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          json.data.forEach((item) => {
            item.isLoad = false;
            item.Loading = false;
          });
          this.addressList = json.data;
          this.isNoData = !json.data.length;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    CollapseChange (val, address) {
      if (val && !address.isLoad) {
        this.searchDetail(address);
      }
    },
    searchDetail (address) {
      address.Loading = true;
      getDesensitizationContractInfoDeatil(this.strContractCode, address.addressName).then((res) => {
        address.Loading = false;
        let json = res.data;
        if (json.status === '200') {
          address = Object.assign(address, json.data);
          address.isLoad = true;
        }
      }).catch(() => {
        address.Loading = false;
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.addressList[0].totalCount;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = Number(this.addressList[0].orderTotalAmount).toFixed(2);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.addressList[0].totalAmount;
          return;
        }
        if (column.label === '已发货数量') {
          sums[index] = this.addressList[0].totalShippedCount;
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.addressList[0].totalUnShippedCount;
          return;
        }
        if (column.label === '销退数量') {
          sums[index] = this.addressList[0].totalSellingBack;
        }
      });
      return sums;
    },
    exportData () {
      this.exportLoading = true;
      axios.get('/export/getExportContractInfo?contractNum=' + this.strContractCode, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '订单明细列表.xls';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportLoading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
